import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageFullMenu from 'Pages/full-menu';

const FullMenu = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Route exact path={`${match.url}/`} component={ PageFullMenu } />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default FullMenu;